import { isLocalPreviewRuntime } from '~/utils/analyticsEnv.js'

type IdleWindow = Window &
  typeof globalThis & {
    requestIdleCallback?: (
      callback: () => void,
      options?: { timeout?: number },
    ) => number
    cancelIdleCallback?: (handle: number) => void
  }

function scheduleAfterInitialLoad(task: () => void, minDelayMs = 12_000) {
  let cancelled = false
  let timeoutId = 0
  let idleId = 0
  const idleWindow = window as IdleWindow

  const runOnIdle = () => {
    if (cancelled) return

    if (typeof idleWindow.requestIdleCallback === 'function') {
      idleId = idleWindow.requestIdleCallback(
        () => {
          if (!cancelled) task()
        },
        { timeout: 8000 },
      )
      return
    }

    timeoutId = window.setTimeout(() => {
      if (!cancelled) task()
    }, 4500)
  }

  const scheduleAfterDelay = () => {
    if (cancelled) return
    timeoutId = window.setTimeout(runOnIdle, minDelayMs)
  }

  if (document.readyState === 'complete') {
    scheduleAfterDelay()
  } else {
    window.addEventListener('load', scheduleAfterDelay, { once: true })
  }

  return () => {
    cancelled = true
    window.removeEventListener('load', scheduleAfterDelay)
    if (idleId && typeof idleWindow.cancelIdleCallback === 'function') {
      idleWindow.cancelIdleCallback(idleId)
    }
    if (timeoutId) {
      window.clearTimeout(timeoutId)
    }
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:mounted', () => {
    if (isLocalPreviewRuntime()) return
    scheduleAfterInitialLoad(() =>
      void import('~/utils/requestVerification').then(({ initializeRequestVerification }) =>
        initializeRequestVerification(),
      ),
    )
  })
})
